import dayjs from "dayjs";

export const MONTH = {
  0: "stycznia",
  1: "lutego",
  2: "marca",
  3: "kwietnia",
  4: "maja",
  5: "czerwca",
  6: "lipca",
  7: "sierpnia",
  8: "września",
  9: "października",
  10: "listopada",
  11: "grudnia"
};

export const prettyDate = date => {
  if (date instanceof dayjs) {
    date = date.toDate();
  } else if (typeof date === "string") {
    date = dayjs(date).toDate();
  }

  const daysFromNow = daysBetween(dayjs(date).toDate(), new Date());

  if (daysFromNow === 0) {
    return "dzisiaj";
  } else if (daysFromNow === 1) {
    return "wczoraj";
  } else if (daysFromNow === 2) {
    return "przedwczoraj";
  } else if (daysFromNow < 7) {
    return `${daysFromNow} dni temu`;
  } else if (daysFromNow === 7) {
    return "tydzień temu";
  } else {
    return `${date.getDate()} ${MONTH[date.getMonth()]} ${date.getFullYear()}`;
  }
};

const daysBetween = (first, second) => {
  const one = new Date(first.getFullYear(), first.getMonth(), first.getDate());
  const two = new Date(
    second.getFullYear(),
    second.getMonth(),
    second.getDate()
  );

  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const millisBetween = +two - +one;
  const days = millisBetween / millisecondsPerDay;

  return Math.floor(days);
};
